import { useState, useEffect } from 'react';
import * as s from './DeploymentBanner.css';
import { VERSION_MISMATCH_EVENT } from '@/shared/lib/version-check/checkVersion';
import { unregisterServiceWorkers, updateServiceWorker } from '@/shared/lib/pwa';

export function DeploymentBanner() {
  const [show, setShow] = useState(false);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    // preventDefault() 하지 않는다 — 하면 Vite 헬퍼가 청크 실패를 undefined 로 resolve 해
    // 라우터가 `undefined.component` 를 읽다 죽는다(2026-09-28 Sentry `u[e]`).
    const preloadHandler = () => {
      setShow(true);
      // 청크 실패 경로는 버전 확인을 거치지 않으므로 여기서 새 워커를 찾아 활성화시킨다.
      void updateServiceWorker();
    };
    const versionHandler = () => setShow(true);

    window.addEventListener('vite:preloadError', preloadHandler);
    window.addEventListener(VERSION_MISMATCH_EVENT, versionHandler);
    return () => {
      window.removeEventListener('vite:preloadError', preloadHandler);
      window.removeEventListener(VERSION_MISMATCH_EVENT, versionHandler);
    };
  }, []);

  if (!show) return null;

  return (
    <div className={s.overlay}>
      <div className={s.banner} role="alert">
        <span className={s.icon} aria-hidden>
          ⚡
        </span>
        <div className={s.textGroup}>
          <span className={s.title}>새 버전이 배포되었습니다</span>
          <span className={s.description}>최신 버전을 사용하려면 새로고침이 필요합니다</span>
        </div>
        <button
          className={s.reloadButton}
          disabled={reloading}
          onClick={() => {
            // 리로드를 해제 뒤에 매달지 않는다 — 해제가 안 깨어나는 환경이 있고, 그러면
            // 버튼이 통째로 죽어 사용자가 연타한다(Sentry Rage Click, 2026-09-14).
            // 해제는 되면 좋은 것이라 성공 여부와 무관하게 리로드로 넘어간다.
            setReloading(true);
            void unregisterServiceWorkers().finally(() => window.location.reload());
          }}
        >
          {reloading ? '새로고침 중…' : '새로고침'}
        </button>
      </div>
    </div>
  );
}
